// Google Analytics (GA4) carregado sob consentimento (LGPD).
//
// O gtag só é injetado DEPOIS de o usuário aceitar a categoria "analytics" no
// banner de consentimento — nunca antes. O ID vem da env `VITE_GA_MEASUREMENT_ID`
// (ex.: "G-XXXXXXXXXX"); enquanto não estiver definido, o carregamento é no-op,
// então dá para deixar o código pronto e plugar o ID depois.
//
// Configurado com anonymize_ip e sem sinais de publicidade (a plataforma não
// veicula anúncios nem faz perfilamento — em especial de crianças).

const MEASUREMENT_ID: string =
  ((import.meta as { env?: Record<string, string | undefined> }).env?.VITE_GA_MEASUREMENT_ID ?? '').trim();

let loaded = false;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/** Carrega o GA4 uma única vez. Só tem efeito se houver ID configurado. */
export function loadAnalytics() {
  if (loaded || !MEASUREMENT_ID || typeof window === 'undefined') return;
  loaded = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    anonymize_ip: true,
    allow_google_signals: false,   // sem sinais de publicidade / remarketing
    allow_ad_personalization_signals: false,
  });
}

/** Evento opcional (só dispara se o GA já foi carregado sob consentimento). */
export function trackEvent(name: string, params?: Record<string, unknown>) {
  if (!loaded || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params ?? {});
}

export const analyticsConfigured = (): boolean => Boolean(MEASUREMENT_ID);
